import { Body1 } from '@cian/ui-kit';

import { type FC } from 'react';

import { type TAwardsSource } from './types';

import styles from './AwardsSources.css';

type TSourcesProps = {
  sources: TAwardsSource[];
};

export const AwardsSources: FC<TSourcesProps> = ({ sources }) => {
  const forbsUrl = sources.find(source => source.type === 'forbes')?.url;

  const uawardsUrl = sources.find(source => source.type === 'uawards')?.url;

  return (
    <Body1 data-testid="AwardsSources">
      Все награды можно посмотреть на&nbsp;сайте{' '}
      <a
        className={styles['source-link']}
        data-testid="AwardsSources-link--urban-awards"
        href={uawardsUrl}
        rel="noreferrer"
        target="_blank"
      >
        Urban Awards
      </a>{' '}
      и{' '}
      <a
        className={styles['source-link']}
        data-testid="AwardsSources-link--forbes"
        href={forbsUrl}
        rel="noreferrer"
        target="_blank"
      >
        Forbes
      </a>
    </Body1>
  );
};
